<template>
    <div class="rounded-md shadow-md p-4 flex flex-row items-center gap-4">
        <div class="w-12 h-12 rounded-md bg-gray-300 animate-pulse flex-shrink-0"></div>
        <div class="w-full space-y-2">
            <div class="h-4 bg-gray-300 rounded w-3/4 animate-pulse"></div>
            <div class="h-3 bg-gray-300 rounded w-1/2 animate-pulse"></div>
        </div>
    </div>
</template>
